import { get } from 'lodash';
import constants from '../../constants.json';

const Roles = constants.roles;
const RolesId = constants.rolesId;

const currentUserEl = document.getElementById('bp-current-user') ? document.getElementById('bp-current-user') : null;
const currentUserData = currentUserEl ? JSON.parse(currentUserEl.value) : null;
const userId = () => get(currentUserData, 'userId', null);
const email = () => get(currentUserData, 'email', null);
const name = () => get(currentUserData, 'name', null);
const activeRole = () => get(currentUserData, 'activeRole', null);
const accessToken = () => get(currentUserData, 'token', null);
const userTimezone = () => currentUserData.timezone;
const locale = () => currentUserData.locale;

const isTimeApprover = () => currentUserData.isTimeApprover;
const isActingAsEmployer = () => activeRole() === Roles.EMPLOYER;
const isActingAsFeatureAdmin = () => activeRole() === Roles.FEATURE_ADMIN;
const isActingAsEmployee = () => activeRole() === Roles.EMPLOYEE;
const isActingAsBpAdmin = () => activeRole() === Roles.BP_ADMIN;
const employerId = () => currentUserData.employerId;
const employerName = () => get(currentUserData, 'employerName', '');
const isActingAsBroker = () => activeRole() === Roles.BROKER;
const isActingAsServiceTeamMember = () => activeRole() === Roles.SERVICE_TEAM;
const doesServiceTeamMemberHaveReadOnlyAccess = () => currentUserData
  .doesServiceTeamMemberHaveReadOnlyAccess;
const masqueraderUserId = () => currentUserData.masqueraderUserId;
const masqueraderUserEmail = () => get(currentUserData, 'masqueraderUserEmail', null);
const masqueraderUserRoleIds = () => currentUserData.masqueraderUserRoleIds;
const isGlobalAdminMasqueradedInEmployer = () => currentUserData.isGlobalAdminMasqueradedInEmployer;
const globalAdminMasqueraderUserId = () => currentUserData.globalAdminMasqueraderUserId;
const isBpAdminMasquerader = () => masqueraderUserId() !== '' && masqueraderUserRoleIds().includes(RolesId.BP_ADMIN);
const isBrokerOrAbove = () => Boolean(currentUserData && currentUserData.isBrokerOrAbove);
const isBenefitProvider = () => Boolean(currentUserData && currentUserData.isBenefitProvider);

export {
  userId,
  email,
  name,
  activeRole,
  accessToken,
  isActingAsEmployer,
  isActingAsFeatureAdmin,
  isActingAsEmployee,
  isActingAsBpAdmin,
  isTimeApprover,
  userTimezone,
  locale,
  employerId,
  employerName,
  isActingAsBroker,
  isActingAsServiceTeamMember,
  doesServiceTeamMemberHaveReadOnlyAccess,
  masqueraderUserId,
  masqueraderUserEmail,
  masqueraderUserRoleIds,
  isGlobalAdminMasqueradedInEmployer,
  globalAdminMasqueraderUserId,
  isBpAdminMasquerader,
  isBrokerOrAbove,
  isBenefitProvider,
};
